"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkCompanyHouseFn = checkCompanyHouseFn;
exports.isDisabled = exports.ifBoolParse = exports.getValue = exports.getRequiredFields = exports.getExtraValues = exports.determineVisibility = void 0;
exports.mergeArraysInObject = mergeArraysInObject;
exports.reviewEditableFields = exports.parseBools = void 0;

var _formValidations = require("./validations/formValidations");

var _lodash = require("lodash");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var flattenForms = function flattenForms(forms) {
  var result = [];
  forms.forEach(function (item) {
    return item.hasOwnProperty('paired') ? item.paired.map(function (field) {
      return result.push(field);
    }) : result.push(item);
  });
  return result;
};

var getRequiredFields = function getRequiredFields(forms) {
  var requiredFields = [];
  Object.keys(forms).forEach(function (key) {
    return flattenForms(forms[key]).map(function (item) {
      return item.hasOwnProperty('validations') && !item.hasOwnProperty('visibility') && item.validations.includes('REQUIRED') && requiredFields.push(item.id);
    });
  });
  return requiredFields;
};

exports.getRequiredFields = getRequiredFields;

var isDisabled = function isDisabled(values, dependency) {
  var depList = [];
  var inputIsDisabled; // This is helpful for disabling the field by default => disabled: true insted of a dep object

  if (dependency === true) return true;
  var valuesSubmitted = Object.keys(values);
  dependency.forEach(function (dep) {
    return depList.push(dep.field);
  });
  var valuesExist = depList.every(function (dep) {
    return valuesSubmitted.includes(dep);
  });
  var valuesAreValids = depList.every(function (value) {
    return !(0, _formValidations.fieldIsEmpty)(values[value]);
  });
  inputIsDisabled = !valuesExist || !valuesAreValids;
  return inputIsDisabled;
};

exports.isDisabled = isDisabled;

var ifBoolParse = function ifBoolParse(string) {
  switch (string) {
    case 'true':
      return true;

    case 'false':
    case undefined:
    case null:
      return false;

    default:
      return string;
  }
};

exports.ifBoolParse = ifBoolParse;

var determineVisibility = function determineVisibility(_ref) {
  var values = _ref.values,
      input = _ref.input,
      inputChangedHandler = _ref.inputChangedHandler;
  var verifyConditions = input.visibility.map(function (condition) {
    var valueToCheck = ifBoolParse(values[condition.field]);
    var res = valueToCheck;

    if (condition.hasOwnProperty('value')) {
      res = valueToCheck === condition.value;
    } else if (condition.values) {
      if (Array.isArray(valueToCheck)) {
        res = valueToCheck.some(function (c) {
          return condition.values.includes(c instanceof Object ? c.identifier || c.value : c);
        });
      } else {
        res = condition.values.includes(valueToCheck instanceof Object ? valueToCheck.identifier || valueToCheck.value : valueToCheck);
      }
    }

    return res;
  });
  var matchedConditions = verifyConditions.every(function (field) {
    return field === true;
  }); //Assigns default value if exists for a not editable required and dependant field

  if (matchedConditions && !input.editable && !values[input.internalName] && input.defaultValue) {
    inputChangedHandler(input.internalName, input.defaultValue);
  }

  return matchedConditions;
};

exports.determineVisibility = determineVisibility;

var parseBools = function parseBools(value) {
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';else if (value === 'true' || value === 'false') return value === 'true' ? 'Yes' : 'No';
  return value;
};

exports.parseBools = parseBools;

var getValue = function getValue(values, input) {
  var path = input.id || input;
  var result;

  if (path.includes('custom.')) {
    path = path.replace('custom.', '');
    result = values.custom ? values.custom[path] : values[path];
  } else {
    result = values[path];
  }

  if (_typeof(result) === 'object') {
    var _result;

    result = ((_result = result) === null || _result === void 0 ? void 0 : _result.value) || result;
  }

  if (input.type === 'CHECK') {
    result = ifBoolParse(result);
  }

  return result;
};

exports.getValue = getValue;

var getExtraValues = function getExtraValues(values, valuesToGet) {
  var extraValues = {};
  valuesToGet.map(function (v) {
    return extraValues[v] = values[v];
  });
  return extraValues;
}; //disableIf = condition (i.e. isEdit), notEditableFields = Array with fields to be disabled


exports.getExtraValues = getExtraValues;

var reviewEditableFields = function reviewEditableFields(_ref2) {
  var form = _ref2.form,
      disableIf = _ref2.disableIf,
      notEditableFields = _ref2.notEditableFields,
      disableAll = _ref2.disableAll;

  if (disableAll) {
    var fields = form[0].form.props.fields.map(function (field) {
      if (field.paired) return _objectSpread(_objectSpread({}, field), {}, {
        paired: field.paired.map(function (singleField) {
          return _objectSpread(_objectSpread({}, singleField), {}, {
            disabled: true
          });
        })
      });else return _objectSpread(_objectSpread({}, field), {}, {
        disabled: true
      });
    });
    return [_objectSpread(_objectSpread({}, form[0]), {}, {
      form: _objectSpread(_objectSpread({}, form[0].form), {}, {
        props: _objectSpread(_objectSpread({}, form[0].form.props), {}, {
          fields: fields
        })
      })
    })];
  } else if (disableIf) {
    var _fields = form[0].form.props.fields.map(function (field) {
      if (field.paired) {
        var paired = field.paired.map(function (singleField) {
          if (notEditableFields.includes(singleField.id)) return _objectSpread(_objectSpread({}, singleField), {}, {
            disabled: true
          });
          return singleField;
        });
        return _objectSpread(_objectSpread({}, field), {}, {
          paired: paired
        });
      } else {
        if (notEditableFields.includes(field.id)) return _objectSpread(_objectSpread({}, field), {}, {
          disabled: true
        });
        return {
          field: field
        };
      }
    });

    return [_objectSpread(_objectSpread({}, form[0]), {}, {
      form: _objectSpread(_objectSpread({}, form[0].form), {}, {
        props: _objectSpread(_objectSpread({}, form[0].form.props), {}, {
          fields: _fields
        })
      })
    })];
  } else {
    return form;
  }
};

exports.reviewEditableFields = reviewEditableFields;

function creditSafeGetCompanies(_x) {
  return _creditSafeGetCompanies.apply(this, arguments);
}

function _creditSafeGetCompanies() {
  _creditSafeGetCompanies = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref3) {
    var url, sendNotification, db, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = _ref3.url, sendNotification = _ref3.sendNotification, db = _ref3.db;
            _context.next = 3;
            return db('get', url).then(function (res) {
              (0, _lodash.isEmpty)(res.company) ? sendNotification({
                text: 'button.noCompanyFound',
                type: 'warning'
              }) : sendNotification({
                text: 'button.companyFilled',
                type: 'success'
              });
              response = res;
            }).catch(function (err) {
              sendNotification({
                text: 'errors.oops',
                type: 'error'
              });
              throw new Error(err);
            });

          case 3:
            return _context.abrupt("return", response);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _creditSafeGetCompanies.apply(this, arguments);
}

function checkCompanyHouseFn(_x2) {
  return _checkCompanyHouseFn.apply(this, arguments);
}

function _checkCompanyHouseFn() {
  _checkCompanyHouseFn = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref4) {
    var values, url, sendNotification, db, response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            values = _ref4.values, url = _ref4.url, sendNotification = _ref4.sendNotification, db = _ref4.db;
            _context2.next = 3;
            return creditSafeGetCompanies({
              url: url,
              sendNotification: sendNotification,
              values: values,
              db: db
            });

          case 3:
            response = _context2.sent;
            !response && sendNotification.checkCompanyHouse();
            return _context2.abrupt("return", response || {});

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _checkCompanyHouseFn.apply(this, arguments);
}

function mergeArraysInObject() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var res = [];

  for (var array in obj) {
    res = [].concat(_toConsumableArray(res), _toConsumableArray(obj[array]));
  }

  return res;
}